// Libraries
import React from "react";
import { Link } from "react-router-dom";

// Assets
import "./../assets/styles/NavBar.css";
import logo from "./../assets/images/vYBox.png";

const NavBar = () => {
    return (
        <header id="navContainer">
            <div id="header">
                <Link to="/" className="zoom"><img className="logo" src={logo} alt="My Logo" /></Link>
            </div>
            <nav className="navLinks">
                <ul>
                    <li className="zoom"><Link to="/" className="link underline">Home</Link></li>
                    <li className="zoom"><Link to="/about" className="link underline">About</Link></li>
                    <li className="zoom"><Link to="/contact" className="link underline">Contact</Link></li>
                </ul>
            </nav>
        </header>
    );
};

export default NavBar;